import { service } from '..';

export const singleActionService = ( actionBase, endPoint, key = 'LOAD', payloadKey = 'data' ) => ( {
  get() {
    return service( endPoint ).get().then( response => ( { type: actionBase[key], [payloadKey]: response.data } ) );
  } 
} );